import React from "react";
import AccordionTwoColumnGrid from "@/components/molecules/AccordionTwoColumnGrid";
import { useTranslation } from "react-i18next";
import Stack from "@/components/atoms/Stack";
import Text from "@/components/atoms/Text";
import SVGAsset from "@/components/atoms/SVGAsset/SVGAsset";
import { Grid } from "@mantine/core";
import { Control, Controller } from "react-hook-form";
import { RegisterCompanyFormInput } from "@/components/pages/RegisterCompany/validation/registerCompanyValidationSchema";
import SelectLanguage from "@/components/molecules/SelectInputs/SelectLanguage";

interface CompanyLanguageProps {
  control: Control<RegisterCompanyFormInput>;
  saveDraft: () => Promise<void>;
}

const CompanyLanguage: React.FC<CompanyLanguageProps> = ({ control, saveDraft }) => {
  const { t } = useTranslation();

  const leftContent = (
    <Stack>
      <Text size="lg" display="technical" tt="uppercase" fw={500} ff="heading" mt={20}>
        {t("registerCompany:language.title")}
      </Text>
      <Grid>
        <Grid.Col span={1} pr={0} mr={0}>
          <SVGAsset name="circle-questionmark" />
        </Grid.Col>
        <Grid.Col span={10} pl={0} ml={0}>
          <Text size="sm" color="secondary">
            {t("registerCompany:language.reason")}
          </Text>
        </Grid.Col>
      </Grid>
    </Stack>
  );

  const rightContent = (
    <Grid>
      <Grid.Col span={12} />
      <Grid.Col span={{ base: 12, sm: 6 }}>
        <Controller
          name="partialCompany.languageId"
          control={control}
          render={({ field: { onChange, value, onBlur }, fieldState }) => {
            return (
              <SelectLanguage
                data-testid="company-language-select"
                required
                valueKey={"id"}
                labelKey={"languageCode"}
                label={t("registerCompany:language.companyLanguage")}
                value={value?.toString() || ""}
                onChange={(e) => onChange(Number(e))}
                onBlur={async () => {
                  onBlur();
                  await saveDraft();
                }}
                error={fieldState.error?.message ? t(fieldState.error.message) : undefined}
              />
            );
          }}
        />
      </Grid.Col>
    </Grid>
  );

  return <AccordionTwoColumnGrid leftContent={leftContent} rightContent={rightContent} />;
};

export default CompanyLanguage;
